import React from "react";
import {Link, withRouter} from "react-router-dom";
import {Col, Container, Row,} from "react-bootstrap";
import {Button, Form, Input, notification, Popconfirm, Select, Spin, Table, Tabs,} from "antd";
import HelperGeneral from "../../../helpers/HelperGeneral";
import ReportDashboard from "../../partials/ReportDashboard";
import moment from "moment";
import Api from "../../../services/Api";
import {setGlobalSpinner} from "../../../services/redux/actions/GeneralAction";
import UserInfo from "../../auth/UserInfo";
import {trans} from "../../../helpers/HelperGlobal";
import AddPharmacyAgent from "./myAccount/AddPharmacyAgent";
import Delivery from "./myAccount/Delivery";
import Profile from "../Profile";
import ContactPreferences from "../ContactPreferences";
import CouponManagement from "./CouponManagement";

class MyAccount extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            active_tab: this.props?.match?.params?.tab_key,
            product_data: [],
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: true,
            transactionType: -1,
            transactionStartDate: '',
            transactionEndDate: '',
            getBasketHeaderAll: {},
            user: UserInfo.info(),
        };

        this.passwordFormRef = React.createRef();

        this.product_history_column = [
            {
                title: 'İşlem Tarihi',
                dataIndex: 'date',
                sorter: false,
                width: 180,
                render: (name, record) => moment(record?.transactionDate).format('DD.MM.YYYY HH:mm'),
            },
            {
                title: 'İşlem Tipi',
                dataIndex: 'product_name',
                render: (name, record) => record?.transactionType === 1 ? 'Kullanım' : 'Kazanım',
                width: 200,
            },
            {
                title: 'Açıklama',
                dataIndex: 'barcode',
                render: (name, record) => (
                    <>
                        {record?.name}
                        <div className={'alt_description'}>{record?.account?.name}</div>
                    </>
                ),
            },
            {
                title: 'Puan',
                dataIndex: 'point',
                width: 150,
                align: 'center',
                render: (name, record) => {
                    return (
                        <div className={record?.transactionType === 1 ? 'minus' : ''}>
                            {record?.transactionType === 2 ? '+' : '-'}{record?.earnedPoint} Puan
                        </div>
                    );
                },
            },
            {
                title: '',
                dataIndex: 'operation',
                width: 130,
                render: (text, record) => (
                    <Popconfirm
                        title="Emin misiniz?"
                        overlayClassName={'border-radius-8'}
                        onConfirm={() => this.transactionRemove(record)}
                    >
                        <Button className={'cancel-button'}>İşlemi İptal Et</Button>
                    </Popconfirm>

                )
            },
        ];
    }

    componentDidMount() {
        const {pagination, user, active_tab} = this.state;
        //this.getTransactions({pagination});
        //this.getBasketHeaderAll();

        if (user?.user_roles_id === 6 && active_tab === 'eczane-yetkilileri') {
            HelperGeneral.pageChange('', '/home');
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const tab_key = this.props?.match?.params?.tab_key;
        if (this.state.active_tab !== tab_key) {
            this.setState({
                active_tab: tab_key
            });
            //this.getBasketHeaderAll();
        }
    }

    // handleTableChange = (pagination, filters, sorter) => {
    //     this.getTransactions({
    //         sortField: sorter.field,
    //         sortOrder: sorter.order,
    //         pagination,
    //         ...filters,
    //     });
    // }

    // getTransactions = (params = {}) => {
    //     this.setState({loading: true}, () => {
    //         Api.getTransactions(
    //             this.state.transactionType,
    //             params.pagination.current,
    //             params.pagination.pageSize,
    //             this.state.transactionStartDate,
    //             this.state.transactionEndDate
    //         ).then(response => {
    //             const result = response.data.result;
    //             this.setState({
    //                 loading: false,
    //                 product_data: result.data,
    //                 pagination: {
    //                     ...params.pagination,
    //                     total: result.page.totalCount,
    //                 },
    //             });
    //         }).catch((e) => {
    //             this.setState({
    //                 loading: false
    //             }, () => HelperGeneral.alert(e));
    //         });
    //     });
    // }

    // transactionRemove = (record) => {
    //     this.setState({
    //         loading: true
    //     }, () => {
    //         Api.transactionRemove(record?.transactionId).then(() => {
    //             this.setState({loading: false}, () => {
    //                 const {pagination} = this.state;
    //                 this.getTransactions({pagination});
    //                 notification['success']({
    //                     message: 'Başarılı!',
    //                     description:
    //                         'İşlem iptali başarıyla gerçekleşti',
    //                 });
    //             })
    //         }).catch((e) => {
    //             this.setState({loading: false}, () => {
    //                 HelperGeneral.alert(e);
    //             });
    //         })
    //     });
    // }

    updatePassword = (e) => {
        setGlobalSpinner(true);

        let data = {
            'old_password': e?.old_password,
            'new_password': e?.new_password,
            'new_password_confirm': e?.new_password_confirm
        };

        Api.changePassword(data).then(r => {
            setGlobalSpinner(false);
            this.passwordFormRef.current.resetFields();
            HelperGeneral.alert('Şifreniz değiştirildi.', 'success');
        }).catch((e) => {
            setGlobalSpinner(false)
            const errorMessage = e?.data?.errors?.old_password?.[0] ?? null;
            HelperGeneral.alert(errorMessage);
        })
    }

    getBasketHeaderAll() {
        const user = UserInfo.info();
        const userId = user.id;

        this.setState({
            loading: true
        }, () => {
            Api.getBasketHeaderAll(userId).then((e) => {
                this.setState({loading: false}, () => {
                    this.setState({
                        getBasketHeaderAll: e.data?.result,
                    });
                })
            }).catch((e) => {
                this.setState({loading: false}, () => {
                    HelperGeneral.alert(e);
                });
            })
        });
    }

    render() {
        const {active_tab, product_data, pagination, loading, transactionType, getBasketHeaderAll, user} = this.state;

        return (
            <div className={'my-account pb-0 pb-sm-5 min-height-container'}>
                <Container>
                    <Row>
                        <Col xs={12} className={'mt-2 mt-sm-4'}>
                            <div className={'username'}>{UserInfo.fullUserName()}</div>
                            <div className={'tab-area'}>
                                <Tabs
                                    activeKey={active_tab}
                                    onChange={(active_tab) => HelperGeneral.pageChange(this, '/my-account/' + active_tab)}
                                >
                                    <Tabs.TabPane tab={'Hesap bilgileri'} key={'bilgilerim'}>
                                        <Profile/>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab={'Şifre değişikliği'} key={'sifre'}>
                                        <div className={'box'}>
                                            <h2>Şifre Değişikliği</h2>
                                            <div className={'description margin'}>
                                                Şifreniz en az 8 karakter olmalı ve en az bir harf ile bir rakam içermelidir.
                                            </div>
                                            <Form
                                                ref={this.passwordFormRef}
                                                layout={'vertical'}
                                                initialValues={{layout: ''}}
                                                onFinish={(e) => this.updatePassword(e)}
                                            >
                                                <Row>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            label={'Mevcut şifreniz'}
                                                            name="old_password"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Mevcut şifrenizi giriniz',
                                                                    min: 8
                                                                },
                                                            ]}
                                                        >
                                                            <Input.Password/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            label={'Yeni şifreniz'}
                                                            name="new_password"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Yeni şifrenizi en az 8 haneli olacak şekilde giriniz',
                                                                    min: 8
                                                                },
                                                            ]}
                                                        >
                                                            <Input.Password/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <Form.Item
                                                            label={'Yeni şifreniz (Tekrar)'}
                                                            name="new_password_confirm"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Yeni şifre tekrarı zorunlu bir alandır',
                                                                    min: 8
                                                                },
                                                                ({getFieldValue}) => ({
                                                                    validator(_, value) {
                                                                        if (!value || getFieldValue('new_password') === value) {
                                                                            return Promise.resolve();
                                                                        }
                                                                        return Promise.reject(new Error('Yeni şifre tekrarı aynı değil'));
                                                                    },
                                                                }),
                                                            ]}
                                                        >
                                                            <Input.Password/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={'auto'} className={'mx-auto'}>
                                                        <Form.Item className={'m-0'}>
                                                            <Button type={"primary"} htmlType={'submit'}>Güncelle</Button>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab={'İletişim Tercihlerim'} key={'iletisim-tercihlerim'}>
                                        <ContactPreferences/>
                                    </Tabs.TabPane>
                                    {
                                        user?.user_roles_id === 4 && (
                                            <Tabs.TabPane tab={'Eczane Yetkilileri'} key={'eczane-yetkilileri'}>
                                                <AddPharmacyAgent/>
                                            </Tabs.TabPane>
                                        )
                                    }
                                    {/*<Tabs.TabPane tab={'Teslimatlarım'} key={'teslimatlarim'}>*/}
                                    {/*    <Delivery/>*/}
                                    {/*</Tabs.TabPane>*/}


                                    {/*<Tabs.TabPane tab={'Puan yönetimi'} key={'score'}>*/}
                                    {/*    <Row>*/}
                                    {/*        <Col>*/}
                                    {/*            <Spin spinning={loading}>*/}
                                    {/*                <div className={'product-history m-0 mt-4 coupon-box'}>*/}
                                    {/*                    <div className={'row'}>*/}
                                    {/*                        <div*/}
                                    {/*                            className={'col-lg-6 col-12 text-lg-start text-center'}>*/}
                                    {/*                            <h3 className={'text-lg-start text-center'}>Kupon*/}
                                    {/*                                Yönetimi</h3>*/}
                                    {/*                            <p className={'text-lg-start text-center'}><br/></p>*/}

                                    {/*                            <Link to={'/my-account/coupon'} >*/}
                                    {/*                                <Button className={'coupon-button mb-3 '}>Kupon*/}
                                    {/*                                    Yükle</Button>*/}
                                    {/*                            </Link>*/}

                                    {/*                        </div>*/}
                                    {/*                        <div className={'col-lg-6 col-12 '}>*/}
                                    {/*                            <div className={'row h-100'}>*/}
                                    {/*                                <div className={'col-lg-4 col-12 '}>*/}
                                    {/*                                    <div className={'row h-100'}>*/}
                                    {/*                                        <div*/}
                                    {/*                                            className={'col-12 d-flex align-items-end justify-content-center title'}>MEVCUT*/}
                                    {/*                                            PUANINIZ*/}
                                    {/*                                        </div>*/}
                                    {/*                                        /!*<div*!/*/}
                                    {/*                                        /!*    className={'col-12 d-flex align-content-center justify-content-center price text-black'}>{getBasketHeaderAll?.UserPoint}*!/*/}
                                    {/*                                        /!*</div>*!/*/}
                                    {/*                                        <div className={'col-12 d-flex align-content-center justify-content-center price text-black'}>*/}
                                    {/*                                            4500*/}
                                    {/*                                        </div>*/}
                                    {/*                                    </div>*/}
                                    {/*                                </div>*/}
                                    {/*                                <div*/}
                                    {/*                                    className={'col-lg-4 col-12 d-flex align-content-center justify-content-center'}>*/}
                                    {/*                                    <img alt={'coupon-money'}*/}
                                    {/*                                         src={require('../../../assets/images/svg/coupon-img.svg').default}*/}
                                    {/*                                         width={80}/>*/}
                                    {/*                                </div>*/}
                                    {/*                                <div className={'col-lg-4 col-12 '}>*/}
                                    {/*                                    <div className={'row h-100'}>*/}
                                    {/*                                        <div className={'col-12 d-flex align-items-end justify-content-center title'}>*/}
                                    {/*                                            TRENDYOL BAKİYENİZ*/}
                                    {/*                                        </div>*/}
                                    {/*                                        /!*<div className={'col-12 d-flex align-content-center justify-content-center price'}>*!/*/}
                                    {/*                                        /!*    {getBasketHeaderAll?.TrendyolCost} TL*!/*/}
                                    {/*                                        /!*</div>*!/*/}
                                    {/*                                        <div className={'col-12 d-flex align-content-center justify-content-center price'}>*/}
                                    {/*                                            6500 TL*/}
                                    {/*                                        </div>*/}
                                    {/*                                    </div>*/}
                                    {/*                                </div>*/}

                                    {/*                            </div>*/}
                                    {/*                        </div>*/}

                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*            </Spin>*/}
                                    {/*        </Col>*/}

                                    {/*        <Col xs={12}>*/}
                                    {/*            <ReportDashboard/>*/}
                                    {/*        </Col>*/}
                                    {/*        <Col>*/}
                                    {/*            <div className={'product-history m-0'}>*/}
                                    {/*                <h3>Puan Kazanım ve Kullanım Geçmişi</h3>*/}
                                    {/*                <div className={'filter mt-3 mb-3'}>*/}
                                    {/*                    <Row>*/}
                                    {/*                        <Col xs={12} md={true} className={'mb-2 mt-3'}>*/}
                                    {/*                            <Select*/}
                                    {/*                                placeholder={'Tüm işlemler'}*/}
                                    {/*                                className={'select2'}*/}
                                    {/*                                onChange={(v) => this.setState({transactionType: v}, () => this.getTransactions({*/}
                                    {/*                                    pagination: {*/}
                                    {/*                                        current: 1,*/}
                                    {/*                                        pageSize: 10*/}
                                    {/*                                    }*/}
                                    {/*                                }))}*/}
                                    {/*                                value={transactionType}*/}
                                    {/*                            >*/}
                                    {/*                                <Select.Option value={-1}>Tüm*/}
                                    {/*                                    işlemler</Select.Option>*/}
                                    {/*                                <Select.Option value={1}>Kullanım</Select.Option>*/}
                                    {/*                                <Select.Option value={2}>Kazanım</Select.Option>*/}
                                    {/*                            </Select>*/}
                                    {/*                        </Col>*/}
                                    {/*                        <Col xs={12} md={true} className={'mb-2 mt-3'}>*/}
                                    {/*                            <Select*/}
                                    {/*                                placeholder={'İşlem aralığı'}*/}
                                    {/*                                className={'select2'}*/}
                                    {/*                                onChange={(v) => {*/}
                                    {/*                                    let transactionStartDate = '',*/}
                                    {/*                                        transactionEndDate = ''*/}
                                    {/*                                    if (v !== -1) {*/}
                                    {/*                                        const a = v.split('-');*/}
                                    {/*                                        const start = moment().subtract(a[0], a[1]);*/}
                                    {/*                                        transactionStartDate = start.format('DD-MM-YYYY');*/}
                                    {/*                                        transactionEndDate = moment().format('DD-MM-YYYY');*/}
                                    {/*                                    }*/}
                                    {/*                                    this.setState({*/}
                                    {/*                                        transactionStartDate,*/}
                                    {/*                                        transactionEndDate*/}
                                    {/*                                    }, () => this.getTransactions({*/}
                                    {/*                                        pagination: {*/}
                                    {/*                                            current: 1,*/}
                                    {/*                                            pageSize: 10*/}
                                    {/*                                        }*/}
                                    {/*                                    }))*/}
                                    {/*                                }}*/}
                                    {/*                            >*/}
                                    {/*                                <Select.Option value={-1}>Tümü</Select.Option>*/}
                                    {/*                                <Select.Option value={'1-week'}>Son 1*/}
                                    {/*                                    hafta</Select.Option>*/}
                                    {/*                                <Select.Option value={'1-month'}>Son 1*/}
                                    {/*                                    ay</Select.Option>*/}
                                    {/*                                <Select.Option value={'3-month'}>Son 3*/}
                                    {/*                                    ay</Select.Option>*/}
                                    {/*                                <Select.Option value={'6-month'}>Son 6*/}
                                    {/*                                    ay</Select.Option>*/}
                                    {/*                                <Select.Option value={'1-year'}>Son 1*/}
                                    {/*                                    yıl</Select.Option>*/}
                                    {/*                            </Select>*/}
                                    {/*                        </Col>*/}
                                    {/*                    </Row>*/}
                                    {/*                </div>*/}
                                    {/*                <Table*/}
                                    {/*                    columns={this.product_history_column}*/}
                                    {/*                    rowKey={record => record.transactionId}*/}
                                    {/*                    dataSource={product_data}*/}
                                    {/*                    pagination={pagination}*/}
                                    {/*                    loading={loading}*/}
                                    {/*                    onChange={this.handleTableChange}*/}
                                    {/*                />*/}
                                    {/*            </div>*/}
                                    {/*        </Col>*/}
                                    {/*    </Row>*/}
                                    {/*</Tabs.TabPane>*/}

                                    {/*<Tabs.TabPane tab={'Kupon yönetimi'} key={'coupon'}>*/}
                                    {/*    <CouponManagement/>*/}
                                    {/*</Tabs.TabPane>*/}
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withRouter(MyAccount);
